import { InitializeApi } from "@ifgengineering/client-notifications-sdk";
import { NOTIFICATION_SERVER } from "gatsby-env-variables";
import axios from "axios";

export const notificationsSdk = InitializeApi({
  serverURL: NOTIFICATION_SERVER,
  appAxios: axios,
});
